import React from 'react'
import SelectDropDown from '../../../../components/elements/SelectDropDown'
import InputCustom from '../../../../components/elements/InputCustom'
import TextAreaCustom from '../../../../components/elements/TextAreaCustom'

function InputsEditProduct({ langLocal, translate, optionCategories, state, optionSubCategories, optionWarehouse, setStateCustom }) {
    return (
        <>
            <div className='d-flex'>
                <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-23`} >
                    <span className={langLocal === 'ar'? "textAlignRight": ""}>{translate('category')}</span>
                    {
                        state.material_category_id !== '' && (
                            <SelectDropDown
                                options={optionCategories}
                                varr={state.material_category_id}
                                setVarr={(value) => setStateCustom('material_category_id', value)}
                                defaultvalue={{ value: state.material_category_id, label: state.material_category_name }}
                            />
                        )
                    }
                </div>
                <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-23`} >
                    <span className={langLocal === 'ar'? "textAlignRight": ""}>{translate('sub_categories')}</span>
                    {
                        state.material_sub_category_id !== '' && (
                            <SelectDropDown
                                options={optionSubCategories}
                                varr={state.material_sub_category_id}
                                setVarr={(value) => setStateCustom('material_sub_category_id', value)}
                                defaultvalue={{ value: state.material_sub_category_id, label: state.material_sub_category_name }}
                            />
                        )
                    }

                </div>
                <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-23`} >
                    <span className={langLocal === 'ar'? "textAlignRight": ""}>{translate('warehouse')}</span>
                    {
                        state.warehouse_id !== '' && (
                            <SelectDropDown
                                options={optionWarehouse}
                                varr={state.warehouse_id}
                                setVarr={(value) => setStateCustom('warehouse_id', value)}
                                defaultvalue={{ value: state.warehouse_id, label: state.warehouse_name }}
                            />
                        )
                    }
                </div>
                <div className={`${langLocal === 'ar' ? "margin_left_10" : "margin_right_10"} one-select w-23`} >
                    <span className={langLocal === 'ar'? "textAlignRight": ""}>{translate('status')}</span>
                    <SelectDropDown
                        options={[{ value: 'active', label: "active" }, { value: 'unactive', label: "unactive" }]}
                        varr={state.status}
                        setVarr={(value) => setStateCustom('status', value)}
                        defaultvalue={{ value: state.status, label: state.status }}
                    />
                </div>
            </div>
            <div className='d-flex' style={{ marginTop: '10px' }} >
                <InputCustom
                    label='name'
                    iconType='pencil'
                    type='text'
                    value1={state?.name}
                    onChange={(e) => setStateCustom('name', e.target.value)}
                />
                <InputCustom
                    label='type'
                    iconType='pencil'
                    type='text'
                    value1={state?.type}
                    onChange={(e) => setStateCustom('type', e.target.value)}
                />
                <InputCustom
                    label='brand'
                    iconType='pencil'
                    type='text'
                    value1={state?.brand}
                    onChange={(e) => setStateCustom('brand', e.target.value)}
                />
                <InputCustom
                    label='model'
                    iconType='pencil'
                    type='text'
                    value1={state?.model}
                    onChange={(e) => setStateCustom('model', e.target.value)}
                />
                <InputCustom
                    label='serial_number'
                    iconType='pencil'
                    type='number'
                    value1={state?.sn}
                    onChange={(e) => setStateCustom('sn', e.target.value)}
                />

            </div>
            <div className='d-flex' style={{ marginTop: '-10px' }} dir={langLocal == "ar" ? "rtl" : "ltr"} >
                <div style={{ width: '555px' }} >
                    <TextAreaCustom
                        label='notes'
                        value={state?.notes}
                        onChange={(e) => setStateCustom('notes', e.target.value)}
                        nameClass='textarea-general'
                    />
                </div>
                <div style={{ width: '555px'}} >
                    <TextAreaCustom
                        label='description'
                        value={state?.description}
                        onChange={(e) => setStateCustom('description', e.target.value)}
                        nameClass='textarea-general'
                    />
                </div>
            </div>
        </>
    )
}

export default InputsEditProduct